/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { HeroAlphaMainStackFragment } from "@cosmos/hygraph-schema";

import { css } from "@panda/css";

import { HeroAlphaHeroImageProps, HeroAlphaHeroImage } from "./HeroAlpha.HeroImage";
import { HeroAlphaMainStack } from "./HeroAlpha.MainStack";

interface Props {
	isBlurred?: boolean;
}

type HeroAlphaContentProps = HeroAlphaMainStackFragment & HeroAlphaHeroImageProps & Props;

const blurred = css({
	position: "relative",
	top: 0,
	height: "100%",
	width: "100%",
	mdDown: {
		position: "static",
	},
});

const fullwidth = css({
	height: "100%",
});

export const HeroAlphaContent = ({
	isBlurred,
	heroAsset,
	logoImage,
	eyebrow,
	title,
	desc,
	buttons,
	modButtons,
	gradient,
	mediaRef,
	crossOrigin,
}: HeroAlphaContentProps): React.JSX.Element | null => {
	if (!heroAsset && !title?.text && !desc && (!buttons || !buttons.length)) return null;

	return (
		<div className={`hero-alpha-content ${isBlurred ? blurred : fullwidth}`}>
			<HeroAlphaMainStack
				isBlurred={isBlurred}
				logoImage={logoImage}
				eyebrow={eyebrow}
				title={title}
				desc={desc}
				buttons={buttons || []}
				modButtons={modButtons || []}
				gradient={gradient}
			/>
			{isBlurred && heroAsset ? (
				<HeroAlphaHeroImage heroAsset={heroAsset} mediaRef={mediaRef} crossOrigin={crossOrigin} />
			) : null}
		</div>
	);
};
